'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');let

BaseControllerBackedDirective=class BaseControllerBackedDirective extends BaseDirective{
get restrict(){
return'E';
}

factory(){
return _.merge({
controller:this.controller,
controllerAs:'controller',
bindToController:!0},
super.factory());
}};


module.exports=BaseControllerBackedDirective;
//# sourceMappingURL=baseControllerBackedDirective.js.map
